import { useDispatch, useSelector } from "react-redux";

import { NO_MODAL } from "../../../constants/ModalConstants";
import getActiveModalSelector from "../../selectors/ModalSelectors/getActiveModalSelector";
import setActiveModalAction from "../../actions/ModalActions/setActiveModalAction";
import { useCallback } from "react";

export function useActiveModal() {
    const activeModal = useSelector((state: Store) => getActiveModalSelector(state));
    const dispatch = useDispatch();
    const setActiveModal = useCallback((active: number = NO_MODAL) => dispatch(setActiveModalAction(active)), [dispatch]);
    return { activeModal, setActiveModal };
}
